import QRCode from "qrcode";
export default {
    name: "modalQrCode",
    props: {
        type: { type: String, required: true },
        id: { type: String, required: true },
        name: { type: String, required: true },
        value: { type: String, required: true },
        visible: { type: Boolean, required: true }, // モーダル表示制御（親から管理）
    },
    watch: {
        // visible が true になったら QR を生成
        visible(val) {
            if (val) {
                this.$nextTick(() => this.generateQr());
            }
        },
    },
    data() {
        return {};
    },
    methods: {
        async generateQr() {
            const canvas = this.$refs.qrCanvas;
            if (!canvas)
                return;
            // 組み立て：type/id/name/value の形式
            // 名前などにスラッシュや空白が入る可能性があるためエンコードしておく
            const payload = [this.type, this.id, this.name, this.value].join("/");
            const options = {
                errorCorrectionLevel: "H",
                margin: 2,
                scale: 8,
                color: {
                    dark: "#000000",
                    light: "#ffffff",
                },
            };
            try {
                await QRCode.toCanvas(canvas, payload, options);
            }
            catch (err) {
                // console.error(err);
            }
        },
        async printQrUsingIframe() {
            const canvas = this.$refs.qrCanvas;
            if (!canvas)
                return;
            // canvas -> Blob (大きい画像で安全)
            const blob = await new Promise((resolve) => {
                if (canvas.toBlob) {
                    canvas.toBlob((b) => resolve(b), "image/png");
                }
                else {
                    // 古いブラウザ用フォールバック（あまり使わない）
                    const dataUrl = canvas.toDataURL("image/png");
                    const byteString = atob(dataUrl.split(",")[1]);
                    const ia = new Uint8Array(byteString.length);
                    for (let i = 0; i < byteString.length; i++)
                        ia[i] = byteString.charCodeAt(i);
                    resolve(new Blob([ia], { type: "image/png" }));
                }
            });
            if (!blob)
                return;
            const url = URL.createObjectURL(blob);
            // iframe を作って非表示で挿入
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            iframe.setAttribute("aria-hidden", "true"); // アクセシビリティ的に非表示
            document.body.appendChild(iframe);
            // iframe の document を取得して最小 HTML を生成（スクリプトを書かないように DOM 操作で画像を挿入）
            const doc = iframe.contentDocument || iframe.contentWindow?.document;
            if (!doc || !iframe.contentWindow) {
                // 失敗したらクリーンアップ
                URL.revokeObjectURL(url);
                if (iframe.parentNode)
                    iframe.parentNode.removeChild(iframe);
                return;
            }
            doc.open();
            doc.write('<!doctype html><html><head><meta charset="utf-8"><title>Print</title>');
            // 印刷時に余計な余白がつかないように印刷用 CSS を入れる（必要に応じて調整）
            doc.write("<style>@media print { html,body { margin:0; height:100%; } body { display:flex; align-items:center; justify-content:center; } img { max-width:100%; max-height:100%; display:block; } }</style>");
            doc.write("</head><body></body></html>");
            doc.close();
            // 画像要素を作って body に追加し、読み込み完了で print を呼ぶ
            const img = doc.createElement("img");
            img.src = url;
            img.alt = "QRコード";
            img.style.maxWidth = "100%";
            img.style.maxHeight = "100%";
            let cleaned = false;
            const cleanup = () => {
                if (cleaned)
                    return;
                cleaned = true;
                try {
                    URL.revokeObjectURL(url);
                }
                catch (e) {
                    // ignore
                }
                try {
                    if (iframe.parentNode)
                        iframe.parentNode.removeChild(iframe);
                }
                catch (e) {
                    // ignore
                }
                window.clearTimeout(fallbackTimer);
            };
            const doPrint = () => {
                try {
                    iframe.contentWindow.focus();
                }
                catch (e) {
                    // ignore
                }
                try {
                    iframe.contentWindow.print();
                }
                catch (e) {
                    // ignore
                }
                // 印刷ダイアログが閉じたあとに自動で iframe を削除したければ、onafterprint を使う試み
                // ただしブラウザ差があるため確実ではない。ここでは少し待って削除する
                setTimeout(cleanup, 500);
            };
            img.onload = () => doPrint();
            img.onerror = () => doPrint(); // 画像読み込み失敗時でも印刷を試みる（必要に応じて変更）
            doc.body.appendChild(img);
            // フォールバック: 何らかの理由で onload が来ない場合のタイムアウト
            const fallbackTimer = window.setTimeout(() => {
                try {
                    iframe.contentWindow?.print();
                }
                catch (e) {
                    // ignore
                }
                cleanup();
            }, 5000);
        },
        close() {
            // 親に閉じるイベントを通知（親側で visible を false にしてください）
            this.$emit("close");
        },
    },
};
